import type { StarterDataTransferObject } from '@mobi/api-types/racePage/types'
import type { IObservableStarter } from '../Model/Observables/IObservableStarter'
import ObservableDogStarter from '../Model/Observables/ObservableDogStarter'
import { BaseRaceCodeBuilder } from './BaseRaceCodeBuilder'

export default class DogBuilder extends BaseRaceCodeBuilder {
  build(source: StarterDataTransferObject): IObservableStarter {
    const result = super.addBaseInformation(
      new ObservableDogStarter(),
      source
    ) as ObservableDogStarter

    result.template('dog-starters-template')
    result.boxNumber(source.Box)
    result.tag('Dog')
    result.stripeCount(source.StripeCount)

    return result
  }
}
